<template>
    <div>
      <van-sticky :offset-top="0">
        <demo-block :title="('')">
          <van-nav-bar :title="('绑定一卡通')" :left-text="('返回')" left-arrow @click-left="this.$router.go(-1)">
            <template #right>
              <van-icon v-if="paytype === 0 || paytype === 1" name="wechat-pay" size="18" />
              <van-icon v-if="paytype === 2" name="alipay" size="18" />
            </template>
          </van-nav-bar>
        </demo-block>
      </van-sticky>
      <van-form @submit="onSubmit" style="margin-top: 9px;">
          <van-cell-group v-if="isbind===false || loginmode==='3'" inset >
            <van-field
              v-model="usercode"
              name="学工号"
              label="学工号"
              placeholder="学工号"
              :rules="[{ required: true, message: '请填写学工号' }]"
            />
            <van-field
              v-model="username"
              name="姓名"
              label="姓名"
              placeholder="姓名"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
          </van-cell-group>
          <van-cell-group title="请输入查询密码，默认身份证后六位，X用0代替" inset >
            <van-password-input
                :value="password"
                :focused="showKeyboard"
                :length="6"
                info="密码为 6 位数字"
                @focus="showKeyboard = true"
                style="margin-top:5px;"
                />
            <van-number-keyboard
                v-model="password"
                :show="showKeyboard"
                @blur="showKeyboard = false"
                />
        </van-cell-group>
        <van-cell-group title="第三方账号登录" inset>
            <van-radio-group v-model="loginmode" direction="horizontal" inset style="margin-left:9px;margin-top: 2px;">
                <van-radio v-if="paytype === 0 && this.$store.state.isenablewxpay===1" name="0" style="height:70px;" @click="ToLoginWx()">
                    微信
                    <template #icon="props">
                        <img class="img-icon" :src="props.checked ? require('/assets/images/wxpayactive.png') : require('/assets/images/wxpayinactive.png')" />
                    </template>
                </van-radio>
                <van-radio v-if="paytype === 1" name="1" style="height:70px;">
                    企业微信
                    <template #icon="props">
                        <img class="img-icon" :src="props.checked ? require('/assets/images/qywxactive.png') : require('/assets/images/qywxinactive.png')" />
                    </template>
                </van-radio>
                <van-radio v-if = "paytype === 2 && this.$store.state.isenablealipay===1" name="2" style="height:70px;" @click="ToLoginAlipay()">
                    支付宝
                    <template #icon="props">
                        <img class="img-icon" :src="props.checked ? require('/assets/images/alipayactive.png') : require('/assets/images/alipayinactive.png')" />
                    </template>
                </van-radio>
                <van-radio  name="3" style="height:70px;">
                    默认登录
                    <template #icon="props">
                        <img class="img-icon" :src="props.checked ? require('/assets/images/ecardactive.png') : require('/assets/images/ecardinactive.png')" />
                    </template>
                </van-radio>
            </van-radio-group>
        </van-cell-group>
        <div v-if="isbind===false" style="margin: 16px;">
          <van-button :loading="isloading" round block type="primary" native-type="submit" loading-text="处理中...">
            提交绑定
          </van-button>
        </div>
      </van-form>
      <br>
      <p align="center">
        <a href="https://beian.miit.gov.cn" id="beian" target="_blank"> {{this.$store.state.beian}}</a>
      </p>
    </div>
  </template>
  
  <script>
  import { GetBrowserType, IsBlank } from '../../utils/tools/index'
  import { Row, Col, Icon, Cell, CellGroup, Form, Field, Button, Popup, Sticky, NavBar, Area, Toast, Calendar, Radio, RadioGroup, NumberKeyboard,PasswordInput, Dialog } from 'vant';
  import { areaList } from '@vant/area-data';
  import { requestUserBind, requestLoginGetWxLoginUrl, requestLoginGetAliPayLoginUrl } from '../../api/api'
  import {  mapActions } from 'vuex'
  
  export default {
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [Icon.name]: Icon,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Form.name]: Form,
      [Field.name]: Field,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Sticky.name]: Sticky,
      [NavBar.name]: NavBar,
      [Area.name]: Area,
      [Calendar.name]: Calendar,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [NumberKeyboard.name]: NumberKeyboard,
      [PasswordInput.name]: PasswordInput
    },
    data() {
      return {
        isloading: false,
        loginmode: 3,
        showKeyboard:false,
        active: 0,
        showArea: false,
        showCalendar: false,
        userSex: '',
        userAddress: '',
        showSex: false,
        userArea: '',
        userbirthday: '',
        areaList: areaList,
        username: '', // 姓名
        usercode: '', // 学工号
        paytype: -1,
        password: '',
        isbind: false

      }
    },
    watch: {
        password (val) {
          if (val.length >=6 ) this.onSubmit()
        },
    },
    computed: {},
    mounted() {
      console.log('mount')
      console.log(this.getLocalLoginInfo())
      this.usercode = this.$store.state.userinfo.outid
      this.isbind = IsBlank(this.usercode) ===false
      this.paytype = GetBrowserType()
      console.log(this.$store.state)
      // window.alert(this.$store.state.getopenid)
      if (this.$store.state.getopenid !=='1') {
        // window.alert('没有获取到openid，开始去登录')
        if(this.paytype=== 0) {
          if (this.$store.state.isenablewxpay===1) this.ToLoginWx()
        } else if(this.paytype=== 2) {
          if (this.$store.state.isenablealipay===1) this.ToLoginAlipay()
        }
      }
    },
    methods: {
      ...mapActions([
        'getLocalLoginInfo',
        'getIsNeedAuthLogin',
        'clearAccessToken',
        'getBaseUserInfo'
      ]),
      async ToLoginAlipay() {
        Toast({
              message: '去使用支付宝登录系统' ,
              icon: 'success',
          })
          this.isloading = true
          console.log('获取支付宝登录链接')
          const res = await requestLoginGetAliPayLoginUrl({localtoken: this.$store.state.token, accesstoken: this.$store.state.accesstoken})
          if (res.return_code === '0') {
                Toast({
                  message: res.return_message ,
                  icon: 'success',
                })
                this.isloading = false
                // 更新accesstoken
                
                setTimeout(() => {
                  window.location.href=(res.data + '&t2=' + new Date().getTime());
                }, 500);
                    
            } else {
              Dialog.alert({
                  title: '错误提醒',
                  message: '获取支付宝登录信息失败：' + res.return_message,
              })
              setTimeout(() => {
                  this.isloading = false
              }, 1000);
            }
        },
        async ToLoginWx() {
          Toast({
              message: '去使用微信登录系统' ,
              icon: 'success',
          })
          this.isloading = true
          // console.log('获取登录链接')
          const res = await requestLoginGetWxLoginUrl({localtoken: this.$store.state.token, accesstoken: this.$store.state.accesstoken})
          if (res.return_code === '0') {
                /*
                Toast({
                  message: res.return_message ,
                  icon: 'success',
                })
                */
                this.isloading = false
                // 更新accesstoken
                
                setTimeout(() => {
                  // window.alert(res.data);
                  // window.location.href=(res.data);
                  // window.open(res.data + '&t2=' + new Date().getTime());
                  window.location.href = res.data + '&t2=' + new Date().getTime();
                }, 300);
                    
            } else {
                Dialog.alert({
                    title: '错误提醒',
                    message: '获取微信公众号登录信息失败：' + res.return_message,
                })
                setTimeout(() => {
                    this.isloading = false
                }, 1000);
                
            }


        },
        async onSubmit () {
          if(this.usercode === undefined || this.usercode === null || this.usercode === '') {
            Toast({
              message: '请输入要绑定的学工号！' ,
              icon: 'success',
            })
            return
          }
          if(this.username === undefined || this.username === null || this.username === '') {
            Toast({
              message: '请输入要绑定的姓名！' ,
              icon: 'success',
            })
            return
          }


          Dialog.confirm({
            title: '绑定确认',
            message: '您确认绑定'+this.username+'['+ this.usercode +']的一卡通账户吗？',
          })
            .then(async () => {
                      this.isloading = true
                      const res = await requestUserBind({loginmode: this.loginmode, localtoken: this.$store.state.token, outid: this.usercode, name: this.username, pwd: this.password})
                      if (res.return_code === '0') {
                          Toast({
                            message: res.return_message ,
                            icon: 'success',
                          })
                          this.isloading = false
                          // 更新accesstoken
                          this.$store.commit('UpdateTokenInfo', res.data)
                          setTimeout(() => {
                              this.$router.push( '/index' +  '?t1=' + new Date().getTime());
                          }, 500);
                            
                      } else {
                          Dialog.alert({
                              title: '错误提醒',
                              message: '绑定失败' + res.return_message,
                          })
                          setTimeout(() => {
                              this.isloading = false
                          }, 1000);
                          
                      }
          })
        },
        OnSelectBirthday (day) {
          console.log(day)
          this.showCalendar = false
          this.userbirthday = `${day.getFullYear()}年${day.getMonth() + 1}月${day.getDate()}日`;
          this.$store.state.userbirthday = this.userbirthday
        },
        onConfirm (areaValues) {
          console.log(areaValues)
          this.showArea = false;
          this.userArea = areaValues
            .filter((item) => !!item)
            .map((item) => item.name)
            .join('/');
          console.log(this.userArea)
          this.$store.state.userArea = this.userArea
        }
    }
  };
  </script>
  
  <style lang="less">
  .user {
    &-poster {
      width: 100%;
      height: 53vw;
      display: block;
    }
  
    &-group {
      margin-bottom: 15px;
    }
  
    &-links {
      padding: 15px 0;
      font-size: 12px;
      text-align: center;
      background-color: #fff;
  
      .van-icon {
        display: block;
        font-size: 24px;
      }
    }
    
  }
  .img-icon {
    height: 20px;
  }
  .van-password-input__security li {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #f50909;
    font-size: var(--van-password-input-font-size);
    line-height: 2.2;
    background: #f8f8f8;
    margin-right: 3px;
}
  </style>
  